import type { BillingInterval, NewUsageProduct, UsageProduct } from '@weft/types';
import type { ProductPriceEstimator } from '../..';
import { getBillingIntervalInMonths } from '../../../billing-settings-number-converter';

export class UsageProductPriceEstimator implements ProductPriceEstimator<UsageProduct | NewUsageProduct, BillingInterval> {
  estimate(product: UsageProduct | NewUsageProduct, billingInterval: BillingInterval) {
    const billingPeriodInMonths = getBillingIntervalInMonths(billingInterval);

    return (product.basePrice ?? 0) * (12 / billingPeriodInMonths);
  }
}